import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CabinetRoutingModule } from './cabinet-routing.module';
import {NbDialogModule} from '@nebular/theme';
import {NbRoleProvider} from '@nebular/security';
import {RoleProviderService} from 'compob2b-auth';
import {AdminSharedModule} from '../admin-shared/admin-shared.module';
@NgModule({
  imports: [
    CommonModule,
    CabinetRoutingModule,
    AdminSharedModule,
    NbDialogModule.forChild()
  ],
  providers: [
    {
      provide: NbRoleProvider,
      useClass: RoleProviderService
    }
  ]
})
export class CabinetModule { }
